module.exports = __webpack_public_path__ + "assets/fonts/GothamRnd-MedIta.70aa508d.otf";